import React from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import stars from "../../../RichImages/stars.svg";

function PrivacyPolicy() {
  return (
    <div>
      <Navbar />
      <div className="privacy-container">
        <div className="d-flex justify-content-center align-items-center ">
          <div className="backgroundoftitle">
            <img
              className="game-icons-img"
              src={stars}
              alt="https://laksh365.com/"
            />
            <h1 class="mb-0 ms-2 me-2 rich-game-title backgroundoftitle">
              Privacy Policy
            </h1>
            <img
              className="game-icons-img"
              src={stars}
              alt="https://laksh365.com/"
            />
          </div>
        </div>
        <main className="privacy-content">
          <section>
            <h2>1. Introduction</h2>
            <p>
              Welcome to Laksh365. This privacy policy explains how we collect,
              use, and safeguard your data when you use our services.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <p>
              We may collect personal data such as your name, email, and usage
              data.
            </p>
          </section>

          <section>
            <h2>3. How We Use Information</h2>
            <p>
              Your data helps us improve our services, provide customer support,
              and send updates.
            </p>
          </section>

          <section>
            <h2>4. Data Security</h2>
            <p>
              We use standard industry protocols to protect your personal
              information.
            </p>
          </section>

          <section>
            <h2>5. Third-Party Services</h2>
            <p>
              We may share your information with trusted partners to help us
              operate our services.
            </p>
          </section>

          <section>
            <h2>6. Changes to this Policy</h2>
            <p>
              We may update this policy occasionally. Changes will be reflected
              on this page.
            </p>
          </section>
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
